import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';

/**
 * ProtectedRoute component to handle authenticated routes
 * If user is not authenticated, redirects to login
 * If user is authenticated but doesn't have the required role, redirects to unauthorized
 */
const ProtectedRoute = ({ 
  element, 
  allowedRoles = [] // Array of roles allowed to access this route
}) => {
  const { isAuthenticated, user, loading } = useContext(AuthContext);
  const location = useLocation();
  
  // If still loading auth status, show loading
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // If roles are specified and user doesn't have the role, redirect to unauthorized
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  // If authenticated and has proper role, render the component
  return element;
};

export default ProtectedRoute;